// 预约揽收中用到，联系人
export const appCollectContacts = {
  contacts: '陆啟宗', // 联系人
  telephone: '18024902500', // 电话
  contactAddress: '广东省佛山市南海区丹灶镇西城社区丽山村工业区4号车间二1楼', // 联系地址
}

// 图片类型
export const imageTypeData = [
  { label: '自拍模特图', value: 0 },
  { label: '网红图', value: 1 },
  { label: '实物摆拍图', value: 2 },
  { label: 'AI图', value: 3 }
];
// 设置中心-物流设置-物流商数据
export const platformExtraData = {
  aboutyou: [
    { valueCode: 'DHL_STD_NATIONAL', valueCnName: 'DHL_STD_NATIONAL' },
    { valueCode: 'HERMES_KLV', valueCnName: 'HERMES_KLV' },
    { valueCode: 'HERMES_STD_NATIONAL', valueCnName: 'HERMES_STD_NATIONAL' },
    { valueCode: 'DHL_AT', valueCnName: 'DHL_AT' },
    { valueCode: 'DHL_POST_AUT', valueCnName: 'DHL_POST_AUT' },
    { valueCode: 'HERMES_POST_AUT', valueCnName: 'HERMES_POST_AUT' },
    { valueCode: 'POST_CH', valueCnName: 'POST_CH' },
    { valueCode: 'QUICK_CH', valueCnName: 'QUICK_CH' },
    { valueCode: 'POST_NL', valueCnName: 'POST_NL' },
    { valueCode: 'DHL_NL', valueCnName: 'DHL_NL' },
    { valueCode: 'DHL_PL', valueCnName: 'DHL_PL' },
    { valueCode: 'PPL', valueCnName: 'PPL' },
    { valueCode: 'ZASIL_CZ', valueCnName: 'ZASIL_CZ' },
    { valueCode: 'BPOST_BE', valueCnName: 'BPOST_BE' },
    { valueCode: 'DHL_BPOST_BEL', valueCnName: 'DHL_BPOST_BEL' },
    { valueCode: 'COLI_FR', valueCnName: 'COLI_FR' },
    { valueCode: 'UB_GLS_DK', valueCnName: 'UB_GLS_DK' },
    { valueCode: 'UB_CORR_ES', valueCnName: 'UB_CORR_ES' },
    { valueCode: 'DS_TB_ES', valueCnName: 'DS_TB_ES' },
    { valueCode: 'UB_CTT_PT', valueCnName: 'UB_CTT_PT' },
    { valueCode: 'DS_TB_PT', valueCnName: 'DS_TB_PT' },
    { valueCode: 'ECONT_BG', valueCnName: 'ECONT_BG' },
    { valueCode: 'ACS_CY', valueCnName: 'ACS_CY' },
    { valueCode: 'UB_OMNIVA_EE', valueCnName: 'UB_OMNIVA_EE' },
    { valueCode: 'UB_POST_FI', valueCnName: 'UB_POST_FI' },
    { valueCode: 'UB_TAXY_GR', valueCnName: 'UB_TAXY_GR' },
    { valueCode: 'ACS_GR', valueCnName: 'ACS_GR' },
    { valueCode: 'POST_HR', valueCnName: 'POST_HR' },
    { valueCode: 'POST_HU', valueCnName: 'POST_HU' },
    { valueCode: 'GLS_HU', valueCnName: 'GLS_HU' },
    { valueCode: 'UB_FAST_IE', valueCnName: 'UB_FAST_IE' },
    { valueCode: 'POST_IT', valueCnName: 'POST_IT' },
    { valueCode: 'DS_TB_IT', valueCnName: 'DS_TB_IT' },
    { valueCode: 'UB_OMNIVA_LT', valueCnName: 'UB_OMNIVA_LT' },
    { valueCode: 'BPOST_LU', valueCnName: 'BPOST_LU' },
    { valueCode: 'UB_OMNIVA_LV', valueCnName: 'UB_OMNIVA_LV' },
    { valueCode: 'UB_POST_NO', valueCnName: 'UB_POST_NO' },
    { valueCode: 'FAN_RO', valueCnName: 'FAN_RO' },
    { valueCode: 'UB_DHL_SE', valueCnName: 'UB_DHL_SE' },
    { valueCode: 'POST_SI', valueCnName: 'POST_SI' },
    { valueCode: 'POST_SK', valueCnName: 'POST_SK' },
    { valueCode: 'ZASIL_SK', valueCnName: 'ZASIL_SK' },
  ]
}
